export const RemoteIconImage = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_158048_12558)">
                <path
                    d="M12.2498 8.75V10.5H13.9998V11.6667H12.2498V13.4167H11.0832V11.6667H9.33317V10.5H11.0832V8.75H12.2498ZM12.2545 1.75C12.5742 1.75 12.8332 2.00958 12.8332 2.32925V7.58333H11.6665V2.91667H2.33317V11.0828L8.1665 5.25L9.9165 7V8.65025L8.1665 6.90025L3.98225 11.0833H8.1665V12.25H1.74517C1.59165 12.2498 1.44446 12.1887 1.33596 12.0801C1.22745 11.9715 1.1665 11.8243 1.1665 11.6708V2.32925C1.16757 2.17605 1.22886 2.02943 1.33714 1.92104C1.44541 1.81266 1.59198 1.75122 1.74517 1.75H12.2545ZM4.6665 4.08333C4.97592 4.08333 5.27267 4.20625 5.49146 4.42504C5.71025 4.64383 5.83317 4.94058 5.83317 5.25C5.83317 5.55942 5.71025 5.85617 5.49146 6.07496C5.27267 6.29375 4.97592 6.41667 4.6665 6.41667C4.35708 6.41667 4.06034 6.29375 3.84155 6.07496C3.62275 5.85617 3.49984 5.55942 3.49984 5.25C3.49984 4.94058 3.62275 4.64383 3.84155 4.42504C4.06034 4.20625 4.35708 4.08333 4.6665 4.08333Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_158048_12558">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
